import { createContext } from "react";

const mainmenuContext = createContext();

export default mainmenuContext;